import { css } from '@emotion/react';

export default css`
  --shadow-0: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
  --shadow-1: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
  --shadow-2: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px,
    rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;

  --shadow-3: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px,
    rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;

  --shadow-4: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
    rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;

  --shadow-5: rgba(0, 0, 0, 0.1) 0px 20px 25px -5px,
    rgba(0, 0, 0, 0.04) 0px 10px 10px -5px;

  --shadow-6: rgba(0, 0, 0, 0.25) 0px 25px 50px -12px;
`;
